import { render, staticRenderFns } from "./NavigationLinks.vue?vue&type=template&id=197fcd02&scoped=true&"
import script from "./NavigationLinks.vue?vue&type=script&lang=js&"
export * from "./NavigationLinks.vue?vue&type=script&lang=js&"
import style0 from "./NavigationLinks.vue?vue&type=style&index=0&id=197fcd02&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "197fcd02",
  null
  
)

export default component.exports